<div class="platform-view-component" *ngIf="domain?.id">
    <div>
        <span>Domain: {{domain.full}}</span>
    </div>
    <div style="padding-top: 15px;" *ngIf="emailTemplates?.length">
        <div *ngFor="let et of emailTemplates">
            <a [routerLink]="['template', 'id', et.id]">{{et.label}}</a>
        </div>
    </div>
</div>
